import { db } from "firebaseConfig";
import firebase from "firebase/compat/app";
import { LISTINGS_REALTOR_SAVED_LISTS_COLLECTION_NAME, CONTACT_FAVORITE_LISTINGS_COLLECTION_NAME } from "../../@types/sharedSchema";

const savedListsCollection = db.collection(LISTINGS_REALTOR_SAVED_LISTS_COLLECTION_NAME);
const favoriteListingsOfContactCollection = db.collection(CONTACT_FAVORITE_LISTINGS_COLLECTION_NAME);

export const addListingsToUserList = async (listId: string, listingIds: string[]) => {
  if (listingIds.length === 0) return;
  
  await savedListsCollection.doc(listId).update({
    listingIds: firebase.firestore.FieldValue.arrayUnion(...listingIds),
  });

  // update the minisite
  await favoriteListingsOfContactCollection.doc(listId).update({
    listingIds: firebase.firestore.FieldValue.arrayUnion(...listingIds),
  });

};

export const removeListingFromUserList = async (listId: string, listingId: string) => {
  await savedListsCollection.doc(listId).update({
    listingIds: firebase.firestore.FieldValue.arrayRemove(listingId),
  });

  // update the minisite
  await favoriteListingsOfContactCollection.doc(listId).update({
    listingIds: firebase.firestore.FieldValue.arrayRemove(listingId),
  });
};

export const createUserList = async (name: string, userId: string) => {
  const newList = {
    name,
    userId,
    listingIds: []
  };
  const docRef = await savedListsCollection.add(newList);

  await createListMinisite(docRef.id, userId, []);

  return docRef.id;
};

export const getUserLists = (userId: string) => {
  return savedListsCollection.where("userId", "==", userId);
};

export const deleteUserList = async (listId: string) => {
  // Delete both the list and its associated minisite
  await Promise.all([
    savedListsCollection.doc(listId).delete(),
    favoriteListingsOfContactCollection.doc(listId).delete()
  ]);
}; 

export const editUserListName = async (listId: string, newName: string) => {
  await savedListsCollection.doc(listId).update({
    name: newName
  });
};

// Create minisite in favorite-listings-of-contact collection for list sharing if it doesn't already exist
export const createListMinisite = async (listId: string, userId: string, listingIds: string[]) => {
  try {
    const existingMinisite = await favoriteListingsOfContactCollection.doc(listId).get();
    
    if (!existingMinisite.exists) {
      const minisiteData = {
        contactId: "",
        realtorId: userId,
        listingIds: listingIds,
        listingsListsIds: [listId],
        additionalDetails: {},
        listingIdsUserLiked: [],
        listingIdsUserDisliked: [],
        listingIdsWithPicturesHidden: []
      };

      await favoriteListingsOfContactCollection.doc(listId).set(minisiteData);
    }
    
  } catch (error) {
    console.error("Error creating list minisite:", error);
    throw error;
  }
};
